const myClassMate = {
  path: 'myClassMate/:myClassId',
  name: 'myClassMate',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/myClassMate'], resolve)
}
export default myClassMate



// WEBPACK FOOTER //
// ./src/router/pages/student_user/myClassMate/index.js